import { faTruckRampCouchSolid } from '@/lib/fa'
import ActivityItem from '@/modules/drivers/forms/activities/components/ActivityItem'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import React from 'react'
import { ActivityType } from '@/app/constants/activity'
import { getActivityTypeNumber } from '@/modules/drivers/helpers/ActivityTypeResolver'
import { getActivityIcon } from '@/modules/drivers/helpers/ActivityIconResolver'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '@/modules/printouts/context/RaportFormContext'

const ACTIVITY_TYPES = [
  ActivityType.AVAILABILITY,
  ActivityType.WORK,
  ActivityType.DRIVING,
  ActivityType.REST,
  ActivityType.UNKNOWN,
]

const ACTIVITY_TYPE_TO_KEY = {
  [ActivityType.AVAILABILITY]: 'availability',
  [ActivityType.WORK]: 'work',
  [ActivityType.DRIVING]: 'driving',
  [ActivityType.REST]: 'rest',
  [ActivityType.UNKNOWN]: 'noData',
}

const ActivityTypeStage = () => {
  const { data, setData } = useRaportForm()

  const { t } = useLocalize()

  const handleActivityToggle = (activityType: ActivityType) => {
    const key = ACTIVITY_TYPE_TO_KEY[activityType]
    if (key) {
      setData({ ...data, [key]: !data[key] })
    }
  }

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <StageHeader
          title={t('printout.activity-type')}
          textSize="sm"
          icon={faTruckRampCouchSolid}
        />

        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
          {ACTIVITY_TYPES.map((a) => {
            const key = ACTIVITY_TYPE_TO_KEY[a]
            return (
              <ActivityItem
                key={a}
                onClick={() => handleActivityToggle(a)}
                icon={getActivityIcon(getActivityTypeNumber(a))}
                label={t(`activityName.${a.toLocaleLowerCase()}`)}
                checked={key ? data[key] : false}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ActivityTypeStage
